import style from '../style/input.module.css'

export default function SeletorQtdMes({mes,setMes,id}) {
  return (
    <select
      name="mes"
      id={id}
      value={mes}
      onChange={(e) => setMes(e.target.value)}
      className={style.seletorQuantidadeMes}
    >
      <option value="meses">Quantidade de meses</option>
      <option value="3meses">3 meses</option>
      <option value="6meses">6 meses</option>
      <option value="9meses">9 meses</option>
      <option value="12meses">12 meses</option>
      <option value="15meses">15 meses</option>
      <option value="18meses">18 meses</option>
      <option value="21meses">21 meses</option>
      <option value="24meses">24 meses</option>
    </select>
  );
}
